// These maps should be placed in each service file,
// have to strip them for being shared with setupProxy.js which use CommonJS module,

const authHostMap = {
  develop: "https://cas.dev.gogoro.cc",
  regression: "https://cas.qa.gogoro.cc",
  staging: "https://cas.gogoro.cc",
  production: "https://cas.gogoro.com",
  k8s: "https://cas.k8s.gogoro.cc",
  globe_develop: "https://cas.dev.gogoro.cc",
  globe_regression: "https://cas.qa.gogoro.cc",
  globe_staging: "https://cas.gogoro.cc",
  globe_production: "https://cas.gogoro.com",
}

const casAddressHostMap = {
  develop: "https://sso.dev.gogoro.cc",
  regression: "https://sso.qa.gogoro.cc",
  staging: "https://sso.gogoro.cc",
  production: "https://sso.gogoro.com",
  globe_develop: "https://sso.dev.gogoro.cc",
  globe_regression: "https://sso.qa.gogoro.cc",
  globe_staging: "https://sso.gogoro.cc",
  globe_production: "https://sso.gogoro.com",
}

const salesHostMap = {
  develop: "https://sales-portal.dev.gogoro.cc",
  regression: "http://sales-portal.qa.gogoro.cc",
  staging: "https://sales.gogoro.cc",
  production: "https://sales.gogoro.com",
  globe_develop: "https://sales-portal.globe.dev.gogoro.cc",
  globe_regression: "http://sales-portal.globe.qa.gogoro.cc",
  globe_staging: "https://sales-portal.globe.gogoro.cc",
  globe_production: "https://sales-portal.gogoro.com.ph",
}

const mobileHostMap = {
  develop: "https://sales-portal-mobile.dev.gogoro.cc",
  // the domain does not config yet in the qa env.
  regression: "https://sales-portal.qa.gogoro.cc",
}

// TODO waiting for the domain defined by PM
const fileUploadHostMap = {
  develop: "https://order-doc.dev.gogoro.cc",
  regression: "https://order-doc.qa.gogoro.cc",
}

const franchiseHostMap = {
  develop: "https://gopartner.dev.gogoro.cc",
  regression: "https://gopartner.qa.gogoro.cc",
  staging: "https://gopartner-portal.gogoro.cc",
  production: "https://gopartner-portal.gogoro.com",
  globe_develop: "",
  globe_regression: "",
  globe_staging: "",
  globe_production: "",
}

/**
 * remove protocal and suffix,
 * the result will be sales(.globe)?.(dev|qa).gogoro.cc
 */
const getCurrentSalesPortalHost = () => {
  const currentEnvironment = process.env.REACT_APP_ENVIRONMENT || "develop"
  const currentApiUrl = salesHostMap[currentEnvironment]
  const currentHost = currentApiUrl.replace(/(^\w+:|^)\/\//, "").replace("-portal", "")
  return currentHost
}

module.exports = {
  authHostMap,
  casAddressHostMap,
  salesHostMap,
  franchiseHostMap,
  mobileHostMap,
  fileUploadHostMap,
  getCurrentSalesPortalHost,
}
